import styled from "styled-components";
import PageWrapper from "../../components/layouts/PageWrapper";
import imgNotFound from "../../static/images/not-found.png";

const NotFoundPage = () => {
  return (
    <PageWrapper>
      <NotFoundPageWrapper>
        <img className="not-found-image" src={imgNotFound} />
        <div className="not-found-content">
          <h1>Mohon maaf, halaman yang Anda cari tidak ditemukan!</h1>
          <p>Apakah Anda yakin sudah mengakses tautan yang benar? Mungkin halamannya sudah dihapus atau dipindahkan ke halaman lain. Untuk informasi lebih lengkap silahkan hubungi tim teknis.</p>
        </div>
      </NotFoundPageWrapper>
    </PageWrapper>
  );
}

const NotFoundPageWrapper = styled.div`
  display: flex;
  min-width: 100%;
  min-height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  
  & > .not-found-image {
    width: 100%;
    max-width: 500px;
  }

  & > .not-found-content {
    width: 100%;
    max-width: 500px;

    & > h1 { 
      font-size: 18px;
      margin-bottom: 15px;
    }

    & > p {
      line-height: 125%;
    }
  }
`;

export default NotFoundPage;